/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiTracksMutationResponse, DeleteApiTracksQueryParams, DeleteApiTracks400, DeleteApiTracks401, DeleteApiTracks403, DeleteApiTracks404, DeleteApiTracks500 } from "../../types/DeleteApiTracks.ts";
import { deleteApiTracksMutationResponseSchema } from "../../zod/TracksSchemas/deleteApiTracksSchema.ts";

function getDeleteApiTracksUrl() {
  const res = { method: 'DELETE', url: `/api/tracks` as const }  
  return res
}

/**
 * @summary Удаление треков
 * {@link /api/tracks}
 */
export async function deleteApiTracks({ params }: { params?: DeleteApiTracksQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiTracksMutationResponse, ResponseErrorConfig<DeleteApiTracks400 | DeleteApiTracks401 | DeleteApiTracks403 | DeleteApiTracks404 | DeleteApiTracks500>, unknown>({ method : "DELETE", url : getDeleteApiTracksUrl().url.toString(), params, ... requestConfig })  
  return deleteApiTracksMutationResponseSchema.parse(res.data)
}